import { request } from '@/utils'
// 获取签名用的url，ios和andriod不同
// wkwebview 内核的坑
const getSignUrl = () => {
  const url = window.location.href.split('#')[0]
  return url
}
// 初始化wechat
export const initWechat = async (param: any = {}) => {
  try {
    const data = { url: getSignUrl() }
    const url = '/wechat/sign'
    let options = {
      title: '企鹅共享·智能洗衣生活服务新体验',
      desc: '智能洗衣生活服务新体验',
      link: window.location.href,
      imgUrl: 'https://static.qiekj.com/static/web/image/logo_1683713526877.png',
      type: 'link',
    }
    options = Object.assign({}, options, param)
    const config = await request({
      method: 'POST',
      url,
      data,
    })
    window?.wx?.config({
      // debug: process.env.NODE_ENV === 'development', // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      debug: false,
      appId: config.appId, // 必填，公众号的唯一标识
      timestamp: config.timeStamp, // 必填，生成签名的时间戳
      nonceStr: config.nonceStr, // 必填，生成签名的随机串
      signature: config.sign, // 必填，签名
      jsApiList: [
        'chooseWXPay',
        'scanQRCode',
        'checkJsApi',
        'getLocation',
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'updateAppMessageShareData',
        'updateTimelineShareData',
      ], // 必填，需要使用的JS接口列表
      openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
    })
    window?.wx?.error(() => {
      // window.location.reload();
    })
    window?.wx?.ready(() => {
      window.wx.updateTimelineShareData({
        title: options.title, // 分享标题
        link: options.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: options.imgUrl, // 分享图标
        desc: options.desc, // 分享描述
        success: function () {
          // 用户点击了分享后执行的回调函数
        },
      })
      window.wx.updateAppMessageShareData({
        title: options.title, // 分享标题
        link: options.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: options.imgUrl, // 分享图标
        desc: options.desc, // 分享描述
        // type: '', // 分享类型,music、video或link，不填默认为link
        // dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户点击了分享后执行的回调函数
        },
      })
    })
  } catch (e) {
    console.log(e)
  }
}
